import React, { useEffect } from 'react';
import { Field, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CommonTextarea from '../../../../../../components/common-textarea/CommonTextarea';
import { STORY_FORM_FIELDS } from '../../../../constants';
import WithError from '../../../../../../components/with-error/WithError';
import { changeSelectedMessage } from '../../../../../../redux/story/storyReducer';

import scss from './ManualMessage.module.scss';

function ManualMessage() {
  const dispatch = useDispatch();
  const { t } = useTranslation('story');

  const selectedMessage = useSelector((state) => state.story.selectedMessage);
  const { input: messageInput } = useField(STORY_FORM_FIELDS.MESSAGE);

  useEffect(() => {
    if (messageInput.value === selectedMessage) {
      return;
    }

    messageInput.onChange(selectedMessage ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMessage]);

  const handleChange = (value) => {
    dispatch(changeSelectedMessage(value));
    messageInput.onChange(value);
  };

  return (
    <div className={scss.wrapper}>
      <Field name={STORY_FORM_FIELDS.MESSAGE}>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <CommonTextarea
              enableVoiceInput
              debounce
              timeout={300}
              rows={4}
              extraInputClass={scss.textarea}
              onChange={handleChange}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              value={input.value}
              placeholder={t('enterYourMessage')}
              isError={meta.touched && meta.error}
            />
          </WithError>
        )}
      </Field>
    </div>
  );
}

export default ManualMessage;
